export default __webpack_public_path__ + "static/media/social-instagram.76a144e0.svg";